import type { WhatsNewBody } from '../types';

export default {
  title: 'What’s new, right in the top bar',
  summary:
    'This list. It shows recent changes for your role, links each one to the part of the training guide that covers it, and shows a number on the button when there is something you haven’t seen.',
  details: [
    'The training guide’s revision and last-reviewed date are at the bottom, so you can see when it last changed.',
  ],
  guide: { topic: 'whats-new' },
} satisfies WhatsNewBody;
